import { doLogout } from "actions/authAction";
import { BASE_URL } from "actions/constant";
export const WHITELIST_MASTER_LIST_DROPDOWN_GET =
  "WHITELIST_MASTER_LIST_DROPDOWN_GET";
export const WHITELIST_GET = "WHITELIST_GET";
export const WHITELIST_ADD = "WHITELIST_ADD";
export const WHITELIST_DELL = "WHITELIST_DELL";
export const WHITELIST_EDIT = "WHITELIST_EDIT";
const whitelistMasterTpartReduc = (bool, list) => {
  return {
    type: WHITELIST_MASTER_LIST_DROPDOWN_GET,
    load: bool,
    val: list.data,
  };
};

const whitelistReduc = (bool, list) => {
  return {
    type: WHITELIST_GET,
    load: bool,
    val: list.data,
  };
};

const whitelistEditReduc = (bool, list) => {
  return {
    type: WHITELIST_EDIT,
    load: bool,
    val: list.status,
  };
};

const whitelistAddReduc = (bool, list) => {
  return {
    type: WHITELIST_ADD,
    load: bool,
    val: list.status,
  };
};

const whitelistDellReduc = (bool, list) => {
  return {
    type: WHITELIST_DELL,
    load: bool,
    val: list.status,
  };
};

export const whitlistGetDataMaster = () => {
  return (dispatch) => {
    dispatch(whitelistMasterTpartReduc(true, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "mst_third_party", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(whitelistMasterTpartReduc(false, data));
        } else {
          window.alert(data.message);
          dispatch(whitelistMasterTpartReduc(false, { data: [] }));
        }
      })
      .catch((err) => {
        window.alert(err);
        dispatch(whitelistReduc(false, { data: [] }));
      });
  };
};

export const whitlistGetData = () => {
  return (dispatch) => {
    dispatch(whitelistReduc(true, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "third_party", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        // if (!response.ok) {
        //     throw Error(response.statusText)
        // }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(whitelistReduc(false, data));
          // dispatch(whitlistGetData())
        } else {
          window.alert(data.message);
          dispatch(whitelistReduc(false, { data: [] }));
        }
      })
      .catch((err) => {
        window.alert(err);
        dispatch(whitelistReduc(false, { data: [] }));
      });
  };
};
export const whitlistEditData = (value) => {
  return (dispatch) => {
    dispatch(whitelistEditReduc(true, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(value),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "third_party", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(whitelistEditReduc(false, data));
        } else {
          window.alert(data.message);
          dispatch(whitelistEditReduc(false, { data: [] }));
        }
      })
      .catch((err) => {
        window.alert(err);
        dispatch(whitelistEditReduc(false, { data: [] }));
      });
  };
};
export const whitelistAdd = (value) => {
  return (dispatch) => {
    dispatch(whitelistAddReduc(true, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(value),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "third_party", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        // if (!response.ok) {
        //     throw Error(response.statusText)
        // }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(whitelistAddReduc(false, data));
        } else {
          window.alert(data.message);
          dispatch(whitelistAddReduc(false, { data: [] }));
        }
      })
      .catch((err) => {
        window.alert(err);
        dispatch(whitelistAddReduc(false, { data: [] }));
      });
  };
};

export const whitelistDell = (value) => {
  return (dispatch) => {
    dispatch(whitelistDellReduc(true, { data: [] }));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(value),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "third_party", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(whitelistDellReduc(false, data));
        } else {
          window.alert(data.message);
          dispatch(whitelistDellReduc(false, { data: [] }));
        }
      })
      .catch((err) => {
        window.alert(err);
        dispatch(whitelistDellReduc(false, { data: [] }));
      });
  };
};
